import { render } from "./SettingsPageSidebar.vue?vue&type=template&id=25d3a59c"
import script from "./SettingsPageSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsPageSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script